import { UserCard, UserCardActions, UserData } from "./UserCard";

interface TeacherData extends Omit<UserData, 'role'> {
  linkedStudents: number;
  subjects: string[];
}

type TeacherCardProps = Omit<UserCardActions, 'userId' | 'onApprove'> & {
  teacher: TeacherData & { role: 'Teacher' };
  teacherId: string;
  className?: string;
};

export const TeacherCard: React.FC<TeacherCardProps> = ({
  teacher,
  teacherId,
  onEdit,
  onDelete,
  onClick,
  className = "",
}) => {
  const userData: UserData = {
    ...teacher,
    role: 'Teacher'
  };

  return (
    <UserCard
      user={userData}
      userId={teacherId}
      onEdit={onEdit}
      onDelete={onDelete}
      onClick={onClick}
      className={className}
    >
      <div className="space-y-3 border-t border-neutral-100 pt-3 mt-3">
        <div className="flex items-center space-x-2">
          <i className="fa-solid fa-users text-neutral-500"></i>
          <span className="text-neutral-600">{teacher.linkedStudents} Linked Student{teacher.linkedStudents !== 1 ? 's' : ''}</span>
        </div>
        
      </div>
    </UserCard>
  );
};
